import {init} from '@enos/comment-client';

const externalWhitelist = ['www.envisioniot.com'];

const head = document.getElementsByTagName('head')[0];

const handleComment = () => {
  const link = document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  // homepage is /docs/
  link.setAttribute('href', '/docs/static/css/waline.css');
  link.setAttribute('type', 'text/css');

  const comment = document.createElement('div');
  comment.setAttribute('id', 'enos-comment-container');
  const footer = document.querySelector('.enos-doc-content .enos-footer-nav');
  if (footer) {
    head.insertAdjacentElement('beforeend', link);
    footer.insertAdjacentElement('afterend', comment);
    const {
      language = ''
    } = window.sphinxEnosThemeHeader || {};

    let versionLan = 'zh-CN';
    if (language === 'en' || language === 'en_us' || language === 'en_US' || language === 'EN_US') {
      versionLan = 'en';
    } else {
      versionLan = 'zh-CN';
    }

    const serverOrigin = `${window.location.protocol}//${window.location.host === 'www.envisioniot.com' ? 'support-cn5.envisioniot.com' : window.location.host}`;
    const params = {
      el: '#enos-comment-container',
      serverURL: `${serverOrigin}/docs/comment`,
      lang: versionLan,
      requiredMeta: ['nick', 'mail'],
      meta: ['nick', 'mail'],
      copyright: false,
      search: false,
      emoji: false,
      comment: true,
      pageview: true
    };

    init(params);
  }
};

// Domain needs to be configured independently. If the domain does not have independent configuration, it will follow the platform's configuration.
// If there is no configuration, it will not be enabled
const isEnableComment = () => {
  if (window.enableComment) {
    if (window.enableComment.length) {
      const currentConfig = window.enableComment.find((item) => item.host === window.location.host); // Configuration for other fields
      const platformConfig = window.enableComment.find((item) => item.host === 'platform'); // Configuration for platform
      if (currentConfig) {
        return !!currentConfig.isEnable;
      }
      return !!platformConfig.isEnable;
    }
    // Compatibility processing
    return !!window.enableComment;
  }
  return false;
};

if (isEnableComment() || externalWhitelist.includes(window.location.host)) {
  handleComment();
} else {
  // Compatible processing, some repos did not apply new themes
  const scriptConfig = document.createElement('script');
  scriptConfig.src = `/docs/config/config.js?${new Date().getTime()}`;
  if (head) {
    head.insertAdjacentElement('beforeend', scriptConfig);
  }
  scriptConfig.onload = () => {
    if (isEnableComment()) {
      handleComment();
    }
  };
}
// };
